export default __webpack_public_path__ + "static/media/s3.0b714566.jpg";